import { useCallback } from 'react';
/* eslint-disable-next-line custom-rules/no-react-i18next */
import { Namespace, useTranslation as useTranslationI18 } from 'react-i18next';

export type TFunction = (key: string, options?: object | string) => string;

export function useTranslation(ns?: Namespace) {
  const { t, ...others } = useTranslationI18(ns);

  const translate = useCallback(
    (key: string, options?: object | string) => {
      const translatedText = t(key, options);
      return typeof translatedText === 'string' ? translatedText : '';
    },
    [t]
  );

  return {
    t: translate,
    ...others
  };
}
